import ProductCard from "@/components/ProductCard";

interface ProductRowProps {
  products: any[];
}

/**
 * PaiMart-style product row: horizontal snap-scroll on mobile,
 * 4-column grid on desktop.
 */
const ProductRow = ({ products }: ProductRowProps) => (
  <>
    {/* Mobile: horizontal scroll */}
    <div className="md:hidden -mx-4 px-4 overflow-x-auto scrollbar-hide">
      <div className="flex gap-3 snap-x snap-mandatory pb-2">
        {products.map((p) => (
          <div key={p.id} className="snap-start shrink-0 w-[44vw] max-w-[180px]">
            <ProductCard product={p} />
          </div>
        ))}
      </div>
    </div>
    {/* Desktop: grid */}
    <div className="hidden md:grid md:grid-cols-4 lg:grid-cols-4 xl:grid-cols-4 gap-4 lg:gap-5">
      {products.map((p) => (
        <ProductCard key={p.id} product={p} />
      ))}
    </div>
  </>
);

export default ProductRow;
